module.exports = __webpack_public_path__ + "img/accesories.63235d14.webp";